import React, {type FC, useContext} from 'react';

import {envIsPublicCloud} from '../../../config';
import {DEFAULT_ONPREM_ORGANIZATION_NAME} from '../../../pages/OrgDashboard/OrgRoles/RolesDashboard';
import * as URL from '../../../util/urls';
import {useNavContext} from '../../NavContextProvider';
import {useIsGlobalRegistryEnabled} from '../../Registries/common/hooks';
import {AccountSelectorContext} from './AccountSelectorContextProvider';
import NavBreadcrumbs from './NavBreadcrumbs';
import NavBreadcrumbsInference from './NavBreadcrumbs/NavBreadcrumbsInference';
import NavBreadcrumbsNotebooks, {
  useForgeNotebookId,
} from './NavBreadcrumbs/NavBreadcrumbsNotebooks';
import {NavBreadcrumbsRegistries} from './NavBreadcrumbs/NavBreadcrumbsRegistries';

const NavLeftDefault: FC = () => {
  const {params, shouldShowBreadcrumbs} = useNavContext();
  const {enableGlobalRegistry} = useIsGlobalRegistryEnabled();
  const {selectedAccount} = useContext(AccountSelectorContext);
  const forgeNotebookId = useForgeNotebookId();
  const accountOrgName = envIsPublicCloud
    ? (selectedAccount?.name ?? '')
    : DEFAULT_ONPREM_ORGANIZATION_NAME;
  if (
    params.entityName == null &&
    URL.isOnRegistriesPage() &&
    enableGlobalRegistry
  ) {
    return (
      <NavBreadcrumbsRegistries
        orgName={accountOrgName}
        registryName={params.registryName}
      />
    );
  }

  if (URL.isOnInferencePage()) {
    return (
      <NavBreadcrumbsInference
        collectionId={params.collectionId}
        modelId={params.modelId}
      />
    );
  }
  if (URL.isOnInferenceComparePage()) {
    return (
      <NavBreadcrumbsInference
        collectionId={params.collectionId}
        modelId={params.modelId}
      />
    );
  }
  if (forgeNotebookId != null) {
    return <NavBreadcrumbsNotebooks notebookId={forgeNotebookId} />;
  }

  if (params.entityName == null || !shouldShowBreadcrumbs) {
    return null;
  }

  return <NavBreadcrumbs />;
};

export default NavLeftDefault;
